import React from 'react';
import { Image, Segment, Button } from 'semantic-ui-react';
import ShadowSeparator from '../../../components/UI_Elements/ShadowSeparator';
import QuoteSlider from './QuoteSlider';
import classes from './mobileRealTalk.css';
import keyIcon from '../../../../assets/images/key_white.svg';
import Link from '../../../../lib/components/link';

const leftQuoteMark = '\u201C';

const MobileRealTalk = () => (
  <div>
    <Segment basic className={classes.realTalkLabel}>
      <div className={classes.realTalkLabelText}>
        REAL TALK
      </div>
      <div className={classes.realTalkLabelUnderline} />
    </Segment>
    <ShadowSeparator />
    <div>
      <div>
        <div className={classes.quote}>
          {leftQuoteMark}
        </div>
        <blockquote className={classes.largeQuoteText}>
          If you want to win your league, use The Huddle. It’s that simple.
          <span className={classes.largeQuoteMark}>”</span>
        </blockquote>
        <p className={classes.attributionNameText}>Paul Friel</p>
        <p className={classes.attributionLabelText}>WCOFF $200,000 Champion</p>
      </div>
    </div>
    <Segment basic className={classes.fullAccessLabel}>
      <span className={classes.fullAccessLabelText}>
        <Image
          src={keyIcon}
          className={classes.keyIcon}
          inline
        />
        <Link to="/subscribe"><span className={classes.fullAccessLabelText}>Ready to start winning?</span></Link>
        <Link to="/subscribe"><Button className={classes.fullAccessButton}>FULL ACCESS </Button></Link>
      </span>
    </Segment>
  </div>
);

export default MobileRealTalk;



// WEBPACK FOOTER //
// ./src/app/components/Footer/MobileFooter/MobileRealTalk.js